module.exports = __webpack_public_path__ + "gb-wls.svg?344dc57e2bbcc26eea7cb4f8211cb5e7";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/gb-wls.svg
// module id = 1463
// module chunks = 0